/**
 * Legacy API Module
 * Base URL: VUE_APP_LEGACY_API (http://localhost:3006/api)
 *
 * 此模組用於呼叫 Legacy 後端 API，與 lioshutanApi.js 完全獨立
 */

import { getLegacyClassrooms } from '../src/legacyClassroom';

// Legacy Classroom API
export const legacyClassrooms = getLegacyClassrooms;

// Default export
export default {
  legacyClassrooms: getLegacyClassrooms,
};
